import { useQuery } from '@tanstack/react-query';
import { http } from '@/network/http';

export interface BreakingNewsItem {
  id: string;
  content: string;
  sourceUrl: string | null;
  sourceName: string | null;
  sourceIconUrl: string | null;
  createdAt: string;
}

export function useBreakingNews() {
  return useQuery({
    queryKey: ['feed', 'breaking'],
    queryFn: async () => {
      const { data } = await http.get('/feed/breaking');
      return data.items as BreakingNewsItem[];
    },
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });
}
